import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'CancelAgreements',
  components: {},
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$root.$on('cancel_agreements_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
      });
    }
  }
};
